// Drucken im CRM (E3, S4) – reine Logik, ohne React: die Seiten-Regeln fürs
// Papier (A4, Ränder, unten die Firma und „Seite x von y“), die die
// Druckansichten (die Unterlage für den Monteur; bis E3c auch die
// Materiallisten des Lagers) als <style> mitbringen,
// solange sie offen sind. So gelten sie nur dort und nicht für jede Seite
// des CRM.
//
// „Seite x von y“ und die Fußzeile stehen in den Randfeldern der Seite
// (@page mit @bottom-left/-right, CSS-Zähler `page` und `pages`). Das können
// Chrome und Edge – das Büro druckt dort (PLAN.md, E3, S3: Memos in Chrome
// oder Edge). Firefox und Safari lassen die Randfelder weg; dann steht die
// Firma trotzdem auf dem Blatt (im Kopf und am Ende), nur ohne Seitenzahl.
// Ob der Browser dazu eigene Kopf- und Fußzeilen druckt (Adresse, Datum),
// stellt man im Druckfenster unter „Kopf- und Fußzeilen“ ein.

/** Ein Text als CSS-Zeichenkette in Anführungszeichen – ohne dass ein Name die Regel aufbrechen kann. */
export function cssText(text: string): string {
  // Steuerzeichen (Zeilenumbruch …) werden Leerzeichen – in CSS beendeten sie die Zeichenkette.
  const sauber = Array.from(text, (z) => (z.charCodeAt(0) < 32 || z.charCodeAt(0) === 127 ? " " : z))
    .join("")
    .replace(/\\/g, "\\\\")
    .replace(/"/g, '\\"');
  return `"${sauber}"`;
}

/**
 * Die Regeln fürs Papier: A4 hochkant, Ränder, unten links `fussLinks`
 * (Firma und was es ist), unten rechts „Seite x von y“.
 */
export function seitenStil(fussLinks: string): string {
  const schrift = `font-family: system-ui, "Segoe UI", Roboto, Arial, sans-serif; font-size: 8.5pt; color: #6b7672;`;
  return [
    "@page {",
    "  size: A4 portrait;",
    "  margin: 14mm 13mm 16mm 13mm;",
    `  @bottom-left { content: ${cssText(fussLinks)}; ${schrift} }`,
    `  @bottom-right { content: "Seite " counter(page) " von " counter(pages); ${schrift} }`,
    "}",
  ].join("\n");
}
